class FreeShiping extends HTMLElement {
  constructor() {
    super();
  }

  formatMoney(cents) {
    const amount = cents / 100;
    const currency = window.Shopify?.currency?.active;

    const formatted = new Intl.NumberFormat(navigator.language, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(amount);

    return currency === 'AUD' ? formatted : `${currency} ${formatted}`;
  }

  connectedCallback() {
    this.render();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.render());
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async render() {
    const thresholdBase = parseFloat(this.dataset.threshold);
    const rate = window.Shopify?.currency?.rate || 1;
    const thresholdCents = Math.round(thresholdBase * rate * 100);

    const cart = await fetch('/cart.js').then(r => r.json());
    const nonGiftTotal = cart.items.filter(i => i.product_type !== 'Gift Cards').reduce((sum, i) => sum + i.final_price * i.quantity, 0);

    const diff = thresholdCents - nonGiftTotal;
    const formattedDiff = this.formatMoney(Math.max(diff, 0));
    const formattedThreshold = this.formatMoney(thresholdCents);

    this.innerHTML = `
      <div class="free-shipping" id="free-shipping" data-id="free-shipping">
        <div class="cart-notification__shipping-progress-bar">
          <progress class="shipping-progress-bar"
            value="${(nonGiftTotal / 100).toFixed(2)}"
            max="${(thresholdCents / 100).toFixed(2)}"
          >
            ${formattedThreshold}
          </progress>
        </div>
        <div class="cart-notification__shipping-message">
          ${diff <= 0 ? `<p>Congrats! Your order gets Free Shipping!</p>` : `<p>Spend <strong class="price">${formattedDiff}</strong> more to unlock free shipping!</p>`}
        </div>
      </div>
    `;
  }
}

customElements.define('fx-freeshipping', FreeShiping);
